


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { IResult, ITask, ITaskValue, ValidationErrors } from "./gip-types";

@Component({
    name: "GoalCard",
})
export default class GoalCard extends Vue {
    @Prop({
        type: String,
        default: "view",
        validator: (value: string) =>
            ["view", "edit", "create"].includes(value),
    })
    private mode!: string;
    private curTab: number = 0; // 0 - задачи, 1 - прямой, 2 - конечный, 3 - KPI

    @Prop({
        type: String,
        default: "projects",
        validator: (value: string) => ["projects", "expenses"].includes(value),
    })
    private context!: string;
    @Prop({ type: String, default: null })
    readonly srcData!: string;

    @Prop({ type: Object, default: () => ({}) }) goal!: any;
    localGoal: any = {};

    private newTaskList: ITask[] = [];
    private newResultList: IResult[] = [];

    @Prop({ type: Array, default: () => [] }) readonly period!: number[];

    @Prop({ required: true }) private unitOptions!: any[];
    private localUnitOptions: any[] = [...this.unitOptions];
    @Prop({ type: Object, default: null }) readonly selectedUnit!: any | null;

    @Prop({ type: Array, default: () => [] }) readonly indicatorOptions!: any[];
    private localIndicatorOptions: any[] = [...this.indicatorOptions];
    @Prop({ type: Object, default: null }) readonly selectedIndicator!:
        | any
        | null;

    @Prop({ required: true }) validationErrors!: ValidationErrors;
    private localValidationErrors: any = { ...this.validationErrors };

    private editingIndex: number | null = null;
    private editingType: "res1" | "res2" | "res3" | "" = "";
    private editingField: "result" | "indicator" | "" = "";
    private editingModal = { ru: "", kz: "" };

    private showGoalNameModal: boolean = false;
    private showTaskNameModal: boolean = false;
    private showResNameModal: boolean = false;

    @Watch("goal", { immediate: true })
    onGoalChanged(newVal: any) {
        this.localGoal = { ...newVal };
    }

    @Watch("unitOptions", { immediate: true })
    onUnitChanged(newOptions: any) {
        this.localUnitOptions = [...newOptions];
    }

    @Watch("indicatorOptions", { immediate: true })
    onIndicatorChanged(newOptions: any) {
        this.localIndicatorOptions = [...newOptions];
    }

    @Watch("period", { immediate: true })
    onPeriodChanged(newPeriod: number[]) {
        if (!Array.isArray(newPeriod) || newPeriod.length === 0) return;

        this.syncWithPeriod(this.newTaskList);
        this.syncWithPeriod(this.newResultList);
    }

    @Watch("validationErrors", { immediate: true, deep: true })
    onValidationErrorsChanged(newVal: Record<string, any>) {
        this.localValidationErrors = { ...newVal };
    }

    private get curLanguage() {
        return this.$i18n.locale || "ru";
    }

    get currentUnit() {
        if (this.selectedUnit) {
            return this.selectedUnit;
        }
    }
    set currentUnit(value: any | null) {
        this.$emit("update:selectedUnit", value);
    }

    get currentIndicator() {
        if (this.selectedIndicator) {
            return this.selectedIndicator;
        }
    }
    set currentIndicator(value: any | null) {
        this.$emit("update:selectedIndicator", value);
    }

    get filteredResultsType1(): IResult[] {
        return this.newResultList.filter((r: IResult) => r.type === 1);
    }

    get filteredResultsType2(): IResult[] {
        return this.newResultList.filter((r: IResult) => r.type === 2);
    }

    get filteredResultsType3(): IResult[] {
        return this.newResultList.filter((r: IResult) => r.type === 3);
    }

    // ================= Задачи ==================

    private addNewTask() {
        if (!this.goal) return;

        const newTask: ITask = {
            id: 0,
            name_ru: "",
            name_kz: "",
            values: this.period.map((year) => ({ year, value: 0 })),
        };

        this.newTaskList.push(newTask);
    }

    private removeTaskInput(index: number) {
        if (index >= 0 && index < this.newTaskList.length) {
            this.newTaskList.splice(index, 1);
        }
    }

    private openTaskNameModal(index: number) {
        this.showTaskNameModal = true;
        this.editingIndex = index;
        const task = this.newTaskList[index];
        if (!task) return;
        this.editingModal.ru = task.name_ru || "";
        this.editingModal.kz = task.name_kz || "";

        (this as any).$bvModal.show("task-edit-modal");
    }

    private saveTaskNameModal() {
        if (this.editingIndex === null) return;

        const task = this.newTaskList[this.editingIndex];
        if (!task) return;
        task.name_ru = this.editingModal.ru;
        task.name_kz = this.editingModal.kz;
        this.clearValidationError(
            `task[${this.editingIndex}].name_ru`,
            task.name_ru
        );
        this.clearValidationError(
            `task[${this.editingIndex}].name_kz`,
            task.name_kz
        );

        this.showTaskNameModal = false;
        this.editingIndex = null;
        this.editingModal = { ru: "", kz: "" };
    }

    // ================= Результаты ==================

    private addNewResult() {
        if (!this.goal) return;

        const typeResult = this.curTab; // 1 - прямой, 2 - конечный, 3 - кпэ

        if (typeResult < 1 || typeResult > 3) return;

        const newResult: IResult = {
            id: 0,
            name_ru: "",
            name_kz: "",
            type: typeResult,
            indicator_ru: "",
            indicator_kz: "",
            unit: 0,
            values: this.period.map((year) => ({ year, value: 0 })),
        };

        this.newResultList.push(newResult);
    }

    private removeResInput(res: IResult) {
        this.newResultList = this.newResultList.filter((r) => r !== res);
    }

    private getResultPrefix(type: number): "res1" | "res2" | "res3" {
        switch (type) {
            case 1:
                return "res1";
            case 2:
                return "res2";
            case 3:
                return "res3";
            default:
                return "res1";
        }
    }

    private openResNameModal(res: IResult, field: "result" | "indicator") {
        this.showResNameModal = true;
        this.editingIndex = this.newResultList.findIndex((r) => r === res);
        this.editingField = field;
        this.editingType =
            this.curTab === 1 ? "res1" : this.curTab === 2 ? "res2" : "res3";

        if (field === "result") {
            this.editingModal.ru = res.name_ru || "";
            this.editingModal.kz = res.name_kz || "";
        } else {
            this.editingModal.ru = res.indicator_ru || "";
            this.editingModal.kz = res.indicator_kz || "";
        }

        (this as any).$bvModal.show("name-edit-modal");
    }

    private saveResNameModal() {
        if (this.editingIndex == null) return;
        const prefix = this.editingType;

        const res = this.newResultList[this.editingIndex];
        if (!res) return;

        let filteredIndex = -1;
        if (prefix === "res1") {
            filteredIndex = this.filteredResultsType1.findIndex(
                (r) => r === res
            );
        } else if (prefix === "res2") {
            filteredIndex = this.filteredResultsType2.findIndex(
                (r) => r === res
            );
        } else if (prefix === "res3") {
            filteredIndex = this.filteredResultsType3.findIndex(
                (r) => r === res
            );
        }

        if (this.editingField === "result") {
            res.name_ru = this.editingModal.ru;
            res.name_kz = this.editingModal.kz;

            if (filteredIndex !== -1) {
                this.clearValidationError(
                    `${prefix}[${filteredIndex}].name_ru`,
                    res.name_ru
                );
                this.clearValidationError(
                    `${prefix}[${filteredIndex}].name_kz`,
                    res.name_kz
                );
            }
        } else if (this.editingField === "indicator") {
            res.indicator_ru = this.editingModal.ru;
            res.indicator_kz = this.editingModal.kz;

            if (filteredIndex !== -1) {
                this.clearValidationError(
                    `${prefix}[${filteredIndex}].indicator_ru`,
                    res.indicator_ru
                );
                this.clearValidationError(
                    `${prefix}[${filteredIndex}].indicator_kz`,
                    res.indicator_kz
                );
            }
        }

        this.editingIndex = null;
        this.editingField = "";
        this.editingType = "";
        this.editingModal = { ru: "", kz: "" };
        this.showResNameModal = false;
    }

    // ================= Общие ==================
    get maxValuesLength(): number {
        return this.newTaskList.length
            ? Math.max(...this.newTaskList.map((task) => task.values.length))
            : 0;
    }

    resetTaskList() {
        this.newTaskList = this.newTaskList.filter((task) => {
            const hasName =
                (task.name_ru && task.name_ru.trim()) ||
                (task.name_kz && task.name_kz.trim());
            const hasValues = task.values?.some(
                (v) => v.value && v.value !== 0
            );
            return hasName || hasValues;
        });

        this.newResultList = this.newResultList.filter((res) => {
            const hasName =
                (res.name_ru && res.name_ru.trim()) ||
                (res.name_kz && res.name_kz.trim());
            const hasIndicator =
                (res.indicator_ru && res.indicator_ru.trim()) ||
                (res.indicator_kz && res.indicator_kz.trim());
            const hasUnit = !!res.unit;
            const hasValues = res.values?.some((v) => v.value && v.value !== 0);

            return hasName || hasIndicator || hasUnit || hasValues;
        });

        this.currentUnit = null;
        this.currentIndicator = null;
        this.curTab = 0;
    }

    public initGoal(goal: any) {
        this.localGoal = {
            name_ru: goal?.name_ru || "",
            name_kz: goal?.name_kz || "",
        };
        this.newTaskList = goal?.tasks
            ? JSON.parse(JSON.stringify(goal.tasks))
            : [];
        this.newResultList = goal?.results
            ? JSON.parse(JSON.stringify(goal.results))
            : [];

        if (Array.isArray(this.period) && this.period.length > 0) {
            this.syncWithPeriod(this.newTaskList);
            this.syncWithPeriod(this.newResultList);
        }
    }

    private openGoalNameModal() {
        if (!this.localGoal) return;
        this.editingModal.ru = this.localGoal.name_ru || "";
        this.editingModal.kz = this.localGoal.name_kz || "";
        this.showGoalNameModal = true;
    }

    private saveGoalNameModal() {
        if (!this.localGoal) return;
        this.localGoal.name_ru = this.editingModal.ru;
        this.localGoal.name_kz = this.editingModal.kz;

        this.clearValidationError("localGoal.name_ru", this.localGoal.name_ru);
        this.clearValidationError("localGoal.name_kz", this.localGoal.name_kz);

        this.showGoalNameModal = false;
        this.$nextTick(() => {
            const el = this.$refs.goalNameInput as HTMLInputElement;
            if (el) {
                el.scrollLeft = 0;
                el.setSelectionRange(0, 0);
            }
        });
    }

    public getGoalData() {
        return {
            name_ru: this.localGoal.name_ru,
            name_kz: this.localGoal.name_kz,
            tasks: this.newTaskList.length ? this.newTaskList : undefined,
            results: this.newResultList.length
                ? this.newResultList.map((r) => {
                      const indicatorFilled =
                          (r.indicator_ru && r.indicator_ru.trim() !== "") ||
                          (r.indicator_kz && r.indicator_kz.trim() !== "") ||
                          (r.indicator &&
                              typeof r.indicator === "string" &&
                              r.indicator !== "") ||
                          (typeof r.indicator === "object" &&
                              r.indicator !== null);

                      const hasValue = r.values.some(
                          (v) => v.value != null && v.value !== 0
                      );

                      return {
                          ...r,
                          unit:
                              hasValue || indicatorFilled
                                  ? typeof r.unit === "object" &&
                                    r.unit !== null
                                      ? r.unit.id
                                      : r.unit
                                  : 0,
                          indicator_id:
                              r.indicator && typeof r.indicator === "object"
                                  ? r.indicator.id
                                  : r.indicator,
                      };
                  })
                : undefined,
        };
    }

    private syncWithPeriod(
        list: Array<{ values?: { year: number | string; value: number }[] }>
    ) {
        if (
            !Array.isArray(list) ||
            !Array.isArray(this.period) ||
            this.period.length === 0
        )
            return;

        // массив годов
        const periodNums = this.period
            .map((y) => Number(y))
            .filter((y) => !Number.isNaN(y));

        list.forEach((item) => {
            const existing = Array.isArray(item.values) ? item.values : [];

            // Map год -> значение
            const valueMap = new Map<number, number>();
            existing.forEach((v) => {
                const yy = Number(v.year);
                if (!Number.isNaN(yy)) valueMap.set(yy, Number(v.value ?? 0));
            });

            // Форм новый массив values по порядку periodNums
            const newValues = periodNums.map((year) => ({
                year,
                value: valueMap.has(year) ? (valueMap.get(year) as number) : 0,
            }));

            if (!Array.isArray(item.values)) {
                this.$set(item, "values", newValues);
            } else {
                item.values.splice(0, item.values.length, ...newValues);
            }
        });
    }

    private hasInvalidChars(value: string | null | undefined): boolean {
        const INVALID_CONTROL_CHARS = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/;
        return typeof value === "string" && INVALID_CONTROL_CHARS.test(value);
    }

    private validateGoalForm(): boolean {
        this.localValidationErrors = {};
        const errors: ValidationErrors = {};
        const textLimit255 = 255;

        const validateName = (
            name: string | number | Record<string, any> | null | undefined,
            label: string,
            key: string,
            hasValue?: boolean
        ) => {
            // проверка на непечатаемые символы
            if (typeof name === "string" && this.hasInvalidChars(name)) {
                errors[key] = true as any;
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.invalid_symbols_err_msg",
                            { f: label }
                        )
                    ),
                    String(this.$t("modules.bank_projects.messages.error_msg"))
                );
            }

            if (
                hasValue &&
                (!name || (typeof name === "string" && name.trim() === ""))
            ) {
                errors[key] = true as any;
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.missing_field_err",
                            { f: label }
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.validate_error")
                    )
                );
            }

            if (typeof name === "string" && name.length > textLimit255) {
                errors[key] = true as any;
                this.makeToast(
                    "warning",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.limit_symbols_err_msg",
                            { f: label, l: textLimit255 }
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.attention_msg")
                    )
                );
            }
        };

        // --- Цель ---
        validateName(
            this.localGoal.name_ru,
            String(this.$t("modules.bank_projects.input_form.name_ru_goal")),
            "localGoal.name_ru",
            true
        );

        validateName(
            this.localGoal.name_kz,
            String(this.$t("modules.bank_projects.input_form.name_kk_goal")),
            "localGoal.name_kz",
            true
        );

        // --- Задачи ---
        this.newTaskList.forEach((t, i) => {
            const hasValue = t.values.some(
                (v) => v.value != null && v.value !== 0
            );
            validateName(
                t.name_ru,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.task_name_ru")`,
                `task[${i}].name_ru`,
                hasValue
            );
            validateName(
                t.name_kz,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.task_name_kk")`,
                `task[${i}].name_kz`,
                hasValue
            );
        });

        // --- Прямые результаты ---
        this.filteredResultsType1.forEach((r, i) => {
            const hasValue = r.values.some(
                (v) => v.value != null && v.value !== 0
            );
            const indicatorFilled =
                (r.indicator_ru && r.indicator_ru.trim() !== "") ||
                (r.indicator_kz && r.indicator_kz.trim() !== "") ||
                (r.indicator &&
                    typeof r.indicator === "string" &&
                    r.indicator !== "") ||
                (typeof r.indicator === "object" && r.indicator !== null);

            const unitEmpty =
                !r.unit ||
                (typeof r.unit === "string" && r.unit === "") ||
                (typeof r.unit === "object" && !r.unit.id);

            if ((hasValue || indicatorFilled) && unitEmpty) {
                errors[`res1[${i}].selectedUnit.unit`] = "error";
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.direct_result_unit_required_msg",
                            { i: i + 1 }
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.attention_msg")
                    )
                );
            }
            validateName(
                r.name_ru,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.direct_result_name_ru")`,
                `res1[${i}].name_ru`,
                hasValue
            );
            validateName(
                r.name_kz,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.direct_result_name_kk")`,
                `res1[${i}].name_kz`,
                hasValue
            );

            // --- Индикатор для режима "projects"---
            if (this.context === "projects") {
                validateName(
                    r.indicator_ru,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.direct_result_indicator_name_ru")`,
                    `res1[${i}].indicator_ru`,
                    hasValue
                );
                validateName(
                    r.indicator_kz,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.direct_result_indicator_name_kk")`,
                    `res1[${i}].indicator_kz`,
                    hasValue
                );
            }

            // --- Индикатор для режима "expenses" ---
            if (this.context === "expenses") {
                validateName(
                    r.indicator,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.direct_result_indicator")`,
                    `res1[${i}].selectedIndicator.indicator`,
                    hasValue
                );
            }
        });

        // --- Конечные результаты ---
        this.filteredResultsType2.forEach((r, i) => {
            const hasValue = r.values.some(
                (v) => v.value != null && v.value !== 0
            );
            const indicatorFilled =
                (r.indicator_ru && r.indicator_ru.trim() !== "") ||
                (r.indicator_kz && r.indicator_kz.trim() !== "") ||
                (r.indicator &&
                    typeof r.indicator === "string" &&
                    r.indicator !== "") ||
                (typeof r.indicator === "object" && r.indicator !== null);

            const unitEmpty =
                !r.unit ||
                (typeof r.unit === "string" && r.unit === "") ||
                (typeof r.unit === "object" && !r.unit.id);

            if ((hasValue || indicatorFilled) && unitEmpty) {
                errors[`res2[${i}].selectedUnit.unit`] = "error";
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.final_result_unit_required_msg",
                            { i: i + 1 }
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.attention_msg")
                    )
                );
            }
            validateName(
                r.name_ru,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.final_result_name_ru)`,
                `res2[${i}].name_ru`,
                hasValue
            );
            validateName(
                r.name_kz,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.final_result_name_kk")`,
                `res2[${i}].name_kz`,
                hasValue
            );

            if (this.context === "projects") {
                validateName(
                    r.indicator_ru,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.final_result_indicator_name_ru")`,
                    `res2[${i}].indicator_ru`,
                    hasValue
                );
                validateName(
                    r.indicator_kz,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.final_result_indicator_name_kk")`,
                    `res2[${i}].indicator_kz`,
                    hasValue
                );
            }

            if (this.context === "expenses") {
                validateName(
                    r.indicator,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.final_result_indicator")`,
                    `res2[${i}].selectedIndicator.indicator`,
                    hasValue
                );
            }
        });

        // --- КПЭ ---
        this.filteredResultsType3.forEach((r, i) => {
            const hasValue = r.values.some(
                (v) => v.value != null && v.value !== 0
            );

            const indicatorFilled =
                (r.indicator_ru && r.indicator_ru.trim() !== "") ||
                (r.indicator_kz && r.indicator_kz.trim() !== "") ||
                (r.indicator &&
                    typeof r.indicator === "string" &&
                    r.indicator !== "") ||
                (typeof r.indicator === "object" && r.indicator !== null);

            const unitEmpty =
                !r.unit ||
                (typeof r.unit === "string" && r.unit === "") ||
                (typeof r.unit === "object" && !r.unit.id);

            if ((hasValue || indicatorFilled) && unitEmpty) {
                errors[`res3[${i}].selectedUnit.unit`] = "error";
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.kpi_unit_required_msg",
                            { i: i + 1 }
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.attention_msg")
                    )
                );
            }
            validateName(
                r.name_ru,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.kpi_name_ru")`,
                `res3[${i}].name_ru`,
                hasValue
            );
            validateName(
                r.name_kz,
                `№${
                    i + 1
                } this.$t("modules.bank_projects.input_form.kpi_name_kk")`,
                `res3[${i}].name_kz`,
                hasValue
            );

            if (this.context === "projects") {
                validateName(
                    r.indicator_ru,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.kpi_indicator_name_ru")`,
                    `res3[${i}].indicator_ru`,
                    hasValue
                );
                validateName(
                    r.indicator_kz,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.kpi_indicator_name_kk")`,
                    `res3[${i}].indicator_kz`,
                    hasValue
                );
            }

            if (this.context === "expenses") {
                validateName(
                    r.indicator,
                    `№${
                        i + 1
                    } this.$t("modules.bank_projects.input_form.kpi_indicator")`,
                    `res3[${i}].selectedIndicator.indicator`,
                    hasValue
                );
            }
        });

        //  проверка числовых значений
        const numericValid = this.validateGoalValues();
        if (!numericValid) {
            this.makeToast(
                "danger",
                String(
                    this.$t(
                        "modules.bank_projects.messages.invalid_numeric_values_msg"
                    )
                ),
                String(this.$t("modules.bank_projects.messages.validate_error"))
            );
            return false;
        }

        this.localValidationErrors = { ...errors };
        this.$emit("validation-complete", { context: "goal", errors });
        return Object.keys(errors).length === 0;
    }

    private validateGoalValues(): boolean {
        let valid = true;

        const checkValues = (arr: any[], prefix: string) => {
            arr.forEach((res, resIndex) => {
                res.values.forEach((v: any, valIndex: any) => {
                    const key = `${prefix}[${resIndex}].values[${valIndex}]`;
                    const num = Number(v.value);

                    if (
                        v.value === "" ||
                        v.value === null ||
                        isNaN(num) ||
                        num < 0
                    ) {
                        this.$set(this.localValidationErrors, key, true);
                        valid = false;
                    } else {
                        this.$delete(this.localValidationErrors, key);
                    }
                });
            });
        };

        checkValues(this.newTaskList, "task");
        checkValues(this.filteredResultsType1, "res1");
        checkValues(this.filteredResultsType2, "res2");
        checkValues(this.filteredResultsType3, "res3");

        return valid;
    }

    private clearValidationError(key: string, value: any) {
        if (!this.localValidationErrors[key]) return;

        const isFilled =
            value != null &&
            (typeof value === "number" ||
                (typeof value === "string" && value.trim() !== "") ||
                (typeof value === "object" &&
                    !Array.isArray(value) &&
                    Object.keys(value).length > 0) ||
                (Array.isArray(value) && value.length > 0));

        if (isFilled) {
            delete this.localValidationErrors[key];
        }
    }

    makeToast(variant: string | undefined, tostbody: any, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            solid: true,
            appendToast: true,
        });
    }
}
